// DOC https://dlatvarg.atlassian.net/wiki/spaces/DAMCO/pages/250741191/Diagrama+de+estados+de+los+reproductores

import * as playerConstant from '../utils/playerConstants';
import { SET_PLAYERS_STATE } from '../actions/playerstates';

const initialState = {
  singlefullplayerstate: {
    currentstate: playerConstant.NOT_PLAYING,
    previousstate: playerConstant.NOT_PLAYING
  },

  singlepipplayerstate: {
    currentstate: playerConstant.NOT_PLAYING,
    previousstate: playerConstant.NOT_PLAYING
  },

  currentplayersstate: playerConstant.E19,
  previousplayersstate: playerConstant.E19
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_PLAYERS_STATE:
      return Object.assign({}, state, action.playerStates);
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/playerstates.js